import { FC } from 'react';
import { InnerIconProps, withIcon } from '@tempusfinance/common-ui';

const SupplyCapErrorComponent: FC<InnerIconProps> = ({ size, color }) => {
  const colorVar = `var(--icon-color, var(${color}))`;

  return (
    <svg
      className="nostra__icon nostra__icon__supplyCapWarning"
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="11" cy="11" r="9" stroke={colorVar} strokeWidth="4" />
      <path d="M11 8.32999V10.9967" stroke={colorVar} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11 13.6633H11.0067" stroke={colorVar} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const SupplyCapError = withIcon(SupplyCapErrorComponent);
